import { cva } from "class-variance-authority";

export const iconContainerVariants = cva(
  "flex size-8 shrink-0 items-center justify-center rounded-full",
  {
    variants: {
      variant: {
        update: "bg-primary/40 text-primary",
        created: "bg-success/40 text-success",
        destructive: "bg-destructive/40 text-destructive",
      },
    },
    defaultVariants: {
      variant: "update",
    },
  },
);
